module.exports = __webpack_public_path__ + "static/img/8areaB_04.cb559e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/8areaB_04.png
// module id = 1224
// module chunks = 1